import Link from 'next/link';
import PreviewCompatibleImage from '../PreviewCompatibleImage';
import PropTypes from 'prop-types';
import breakpoint from 'styled-components-breakpoint';
import { rem } from 'polished';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const Article = styled.article`
  padding-top: 0;
  margin-bottom: 5rem;

  a {
    display: block;
    color: ${theme('colors.blue')};
    &:hover {
      &,
      aside,
      h3 {
        color: ${theme('colors.orange')};
      }
    }
  }

  figure {
    margin-bottom: 1rem;
  }

  h3 {
    margin: 1rem 0 0 0;
    color: ${theme('colors.blue')};
    font-weight: bold;
    font-size: ${rem(32)};
    ${breakpoint('sm', 'md')`
      font-size: ${rem(24)};
    `}
    ${breakpoint('xs', 'sm')`
      font-size: ${rem(24)};
    `}
  }

  aside {
    color: ${theme('colors.blue')};
    font-size: ${rem(16)};
  }
`;

const ListItem = ({ title, metaDescription, slug, mainImage, priority }) => {
  if (!slug) {
    return null;
  }

  return (
    <Article>
      <Link href={`/blog/${slug.current}`}>
        <figure>
          {mainImage && (
            <PreviewCompatibleImage
              imageInfo={{
                image: mainImage.image,
                alt: mainImage.image.alt || title,
                width: 800,
              }}
              priority={priority}
            />
          )}
          <figcaption>
            <h3>{title}</h3>
          </figcaption>
        </figure>
        <aside>
          <p>{metaDescription}</p>
        </aside>
      </Link>
    </Article>
  );
};

ListItem.propTypes = {
  title: PropTypes.string.isRequired,
  metaDescription: PropTypes.string,
  slug: PropTypes.object.isRequired,
  mainImage: PropTypes.object.isRequired,
  priority: PropTypes.bool,
};

export default ListItem;
